export const LogoMark = ({ size = 36 }) => (
  <img
    src="/favicon.png"
    alt="Apexa Link"
    width={size}
    height={size}
    style={{ objectFit: "contain", display: "block" }}
  />
);

export const LogoFull = ({ size = 46 }) => (
  <img
    src="/logo.png"
    alt="Apexa Link"
    style={{ height: size, width: "auto", display: "block" }}
  />
);
